import React from 'react';
import CustomerEvaluationList from './CustomerEvaluationList';

/** Úplné vyhodnotenie (cust002): rovnaké UI ako cust001, scope cez complete_list API. */
export default function CustomerEvaluationCompleteList() {
  return (
    <CustomerEvaluationList endpointPrefix="/api/customer_evaluations/complete_list" />
  );
}
